import Avatar from "components/Avatar";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-responsive-modal";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useToasts } from "react-toast-notifications";
import WellnessService from "services/WellnessService";
import DefaultTeamAvatar from "assets/img/HandsColorAvatar.jpeg";
import { Scrollbar } from "react-scrollbars-custom";
import { ReactComponent as Checkbox } from "assets/img/icons/checkbox.svg";
import { ReactComponent as UnCheckBox } from "assets/img/icons/uncheckbox.svg";
import Button from "components/CustomButton";
import Loader from "components/Loader";

const styles = {
  headingDailog: { fontWeight: "600" },
  listIteamHeading: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px",
    gap: "15px",
    borderBottom: "1px solid #ccc",
  },
  listItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    borderBottom: "1px solid #ccc",
  },
  teamDetail: { display: "flex", gap: "10px", fontWeight: "400", alignItems: "center" },
  listContainer: { display: "flex", flexDirection: "column" },
  avatar: { minHeight: "30px", height: "30px", minWidth: "30px", width: "30px", borderRadius: "50%" },
  teamNameAll: { fontWeight: "bolder" },
  uncheckbox: { width: "20px", height: "20px" },
  checkbox: { width: "23px", height: "23px" },
  rightButton: { position: "absolute", top: "0", right: "0" },
  noTeams: { width: "100%", display: "flex", flexDirection: "column", alignItems: "center" },
  doneButton: {
    cursor: "pointer",
    width: "100px",
    background: "none",
    height: "unset",
    color: "#ffa100",
    boxShadow: "unset",
  },
  dialogTitle: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: "0 0 auto",
    margin: 0,
    padding: "12px 0px 12px",
  },
};

const ShareTrainingDocument = ({ onClose, documentId }) => {
  const [checkedTeams, setCheckedTeams] = useState([]);
  const [allSelectDeSel, setAllSelectDeSel] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const params = useParams();
  const { teams } = useSelector((state) => state.teamsReducer);
  const { addToast } = useToasts();

  const submitValues = async () => {
    try {
      setSubmitting(true);
      await WellnessService.shareTrainingDocument(params.teamId, documentId, {
        team_ids: checkedTeams,
      });
      addToast("Document shared to selected teams.", { appearance: "success" });
      setSubmitting(false);
      onClose();
    } catch ({ response }) {
      addToast(response?.data?.message ?? "Failed to share document.", { appearance: "error" });
      setSubmitting(false);
    }
  };

  const handleSelectOrDeselect = () => {
    setAllSelectDeSel(!allSelectDeSel);
    setCheckedTeams(!allSelectDeSel ? teams.map((e) => e.id) : []);
  };

  const handleTeamCheck = (target, id) => {
    if (target) {
      setCheckedTeams((prev) => [...prev, id]);
    } else {
      setCheckedTeams((prev) => prev.filter((e) => e !== id));
    }
  };

  useEffect(() => {
    setAllSelectDeSel(checkedTeams.length === teams.length);
  }, [checkedTeams, teams.length]);

  return (
    <Modal
      closeOnEsc={false}
      closeOnOverlayClick={false}
      classNames={{ modalContainer: "modalContainer", modal: "shareModalPadding" }}
      showCloseIcon={false}
      open
      onClose={onClose}
    >
      <div className="modal fade popup-modal">
        <div className="modal-content">
          <div className="modal-body">
            <div style={styles.listContainer}>
              <div style={styles.dialogTitle}>
                <h5 style={styles.headingDailog}>Select Teams</h5>
                {teams?.length > 0 && (
                  <div style={styles.rightButton}>
                    <Button
                      buttonStyle={styles.doneButton}
                      onClick={submitValues}
                      type="button"
                      name={!submitting ? "Done" : <Loader width={20} height={20} />}
                      disabled={(teams.length === 0 || submitting) && true}
                    />
                  </div>
                )}
              </div>
              <Scrollbar style={{ paddingRight: "10px", height: "60vh" }}>
                {teams?.length > 0 && (
                  <div style={styles.listIteamHeading}>
                    <div style={styles.teamDetail}>
                      <span style={styles.teamNameAll}>
                        {checkedTeams.length === teams.length ? "Deselect All" : "Select All"}
                      </span>
                    </div>
                    {checkedTeams.length !== teams.length && (
                      <UnCheckBox onClick={handleSelectOrDeselect} style={styles.uncheckbox} />
                    )}
                    {checkedTeams.length === teams.length && (
                      <Checkbox onClick={handleSelectOrDeselect} style={styles.checkbox} />
                    )}
                  </div>
                )}
                {teams
                  ?.filter((t) => t.id !== Number(params.teamId))
                  ?.map((allteam) => (
                    <div style={styles.listItem} key={allteam.id}>
                      <div style={styles.teamDetail}>
                        <Avatar
                          alt={allteam.name}
                          rootStyle={styles.avatar}
                          src={allteam.avatar ?? DefaultTeamAvatar}
                        />
                        <span>{allteam.name}</span>
                      </div>
                      {!checkedTeams.includes(allteam.id) && (
                        <UnCheckBox
                          style={styles.uncheckbox}
                          onClick={() => handleTeamCheck(true, allteam.id)}
                        />
                      )}
                      {checkedTeams.includes(allteam.id) && (
                        <Checkbox
                          style={styles.checkbox}
                          onClick={() => handleTeamCheck(false, allteam.id)}
                        />
                      )}
                    </div>
                  ))}
                {teams?.length === 0 && (
                  <div style={styles.noTeams}>
                    <p>You don't have any teams.</p>
                  </div>
                )}
              </Scrollbar>
            </div>
            <div>
              <Button
                type="button"
                disabled={submitting && true}
                buttonClass="small-btn me-2"
                name="Cancel"
                onClick={onClose}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ShareTrainingDocument;
